import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from './theme';
import AppWithRouterAccess from '../Base/AppWithRouterAccess';


const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router basename={"apollo"}>
        <AppWithRouterAccess/>
      </Router>
    </ThemeProvider>
  );
}
export default App;
